/// <reference path="../../../typings/tsd.d.ts" />
module warsApp.directives {
    export interface IFilterFeatureCollectionScope extends angular.IScope {
        configuration: Wars.Domain.Model.Gis.FilterFeatureCollectionConfiguration;
        addAttribute: any;
        deleteAttribute: any;
        save: any;
        inputCollection: Wars.Domain.Model.Gis.GisInputOutputCollection;
    }

    export class FilterFeatureCollectionConfiguration implements IDirective {
        public link($scope: IFilterFeatureCollectionScope, element: JQuery, attrs: ng.IAttributes) {
        }

        public templateUrl = "./app/views/directives/gis/filterFeatureCollectionConfiguration.html";
        public restrict: string = "E";
        public controller = ["$scope", 'mapConfigurationService', FilterFeatureCollectionConfigurationController];
        public controllerAs = "controller";
        public scope: any = {
            configuration: "=",
            inputCollection: "="
        };
    }

    export class FilterFeatureCollectionConfigurationController {
        constructor(private $scope: IFilterFeatureCollectionScope, private mapConfigurationService: services.MapConfigurationService) {
            $scope.save = () => mapConfigurationService.saveAllChanges();
            $scope.addAttribute = () => this.addAttribute();
            $scope.deleteAttribute = (a) => this.deleteAttribute(a);
        }

        private addAttribute() {
            let newAttr = this.mapConfigurationService.createFilterAttribute();
            newAttr.compareOperator = Wars.Domain.Model.Codes.Enums.CompareOperator.Equals;

            this.$scope.configuration.filterAttributes.push(newAttr);

            this.mapConfigurationService.saveAllChanges();

        }

        private deleteAttribute(attr: Wars.Domain.Model.Gis.FilterAttribute) {
            attr.entityAspect.setDeleted();

            this.mapConfigurationService.saveAllChanges();
        }
    }
}

warsApp.registerDirective('FilterFeatureCollectionConfiguration', []);
